import React, { useState, useContext } from 'react';
import { HistoryPickupsContext } from 'contexts/HistoryPickupsContext';
import { Search, X } from 'lucide-react';

export const HistoryPickupsFilter: React.FC = () => {
  const { applyFilters } = useContext(HistoryPickupsContext);

  const [rqps, setRqps] = useState('');
  const [clientName, setClientName] = useState('');
  const [carrier, setCarrier] = useState('');
  const [requestDate, setRequestDate] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [status, setStatus] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    applyFilters({ rqps, clientName, carrier, requestDate, invoiceNumber, status });
  };

  const handleClear = () => {
    setRqps('');
    setClientName('');
    setCarrier('');
    setRequestDate('');
    setInvoiceNumber('');
    setStatus('');
    applyFilters({});
  };

  return (
    <form 
      onSubmit={handleSearch}
      className="w-full bg-gray-50 p-4 rounded-md border border-gray-200 mb-6 flex flex-col sm:flex-row items-end gap-4"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">RQPS</label>
          <input
            type="text"
            value={rqps}
            onChange={(e) => setRqps(e.target.value)}
            placeholder="Ex: Corteva"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div className="flex-1 w-full">
          <label className="block text-xs font-semibold text-gray-600 mb-1">Cliente</label>
          <input
            type="text"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            placeholder="Nome do cliente"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div className="flex-1 w-full">
          <label className="block text-xs font-semibold text-gray-600 mb-1">Transportadora</label>
          <input
            type="text"
            value={carrier}
            onChange={(e) => setCarrier(e.target.value)}
            placeholder="Nome da transportadora"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Data de Solicitação</label>
          <input
            type="date"
            value={requestDate}
            onChange={(e) => setRequestDate(e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-gray-700"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Número da NF</label>
          <input
            type="text"
            value={invoiceNumber}
            onChange={(e) => setInvoiceNumber(e.target.value)}
            placeholder="Apenas números"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Status</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-gray-700"
          >
            <option value="">Todos</option>
            <option value="concluida">Concluída</option>
            <option value="cancelada">Cancelada</option>
          </select>
        </div>

        <div className="flex flex-row gap-2 w-full sm:w-auto">
          <button
            type="button"
            onClick={handleClear}
            className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 transition-colors"
            title="Limpar filtros"
          >
            <X size={16} />
            Limpar
          </button>
          <button
            type="submit"
            className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-4 py-2 bg-[#EE7C2C] text-white text-sm font-medium rounded-md hover:bg-[#ED8C49] transition-colors shadow-sm"
          >
            <Search size={16} />
            Filtrar
          </button>
        </div>
      </div>
    </form>
  );
};